import getApiBase from "../../getApiBase";

async function calendarFetch(path, options = {}) {
  const { headers: optionHeaders, ...rest } = options;
  const res = await fetch(`${getApiBase()}/api/calendar${path}`, {
    credentials: "include",
    ...rest,
    headers: {
      "Content-Type": "application/json",
      ...(optionHeaders || {}),
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || `Calendar API error (${res.status})`);
  }
  return data;
}

export function fetchCalendarProviders() {
  return calendarFetch("/providers");
}

export function fetchCalendarConfig(shopId) {
  return calendarFetch(`/config/${shopId}`);
}

export function updateCalendarConfig(shopId, body) {
  return calendarFetch(`/config/${shopId}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export function connectCalendarProvider(shopId, body) {
  return calendarFetch(`/connect/${shopId}`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function fetchCalendarEvents(shopId, from, to) {
  const params = new URLSearchParams({ from, to });
  return calendarFetch(`/events/${shopId}?${params.toString()}`);
}

export function fetchCalendarEventDetail(shopId, eventId) {
  return calendarFetch(`/events/${shopId}/${eventId}`);
}

export function createCalendarEvent(shopId, body, idempotencyKey) {
  const headers = {};
  if (idempotencyKey) {
    headers["Idempotency-Key"] = idempotencyKey;
  }
  return calendarFetch(`/events/${shopId}`, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });
}

export function updateCalendarEvent(shopId, eventId, body) {
  return calendarFetch(`/events/${shopId}/${eventId}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export function cancelCalendarEvent(shopId, eventId) {
  return calendarFetch(`/events/${shopId}/${eventId}`, {
    method: "DELETE",
  });
}

/** Part 2 — same cancel path as Mechanics Dashboard for SR-linked appointments. */
export async function cancelServiceRequestFromCalendar(serviceRequestId, { shopId, reason }) {
  const res = await fetch(`${getApiBase()}/api/serviceRequest/cancel/${serviceRequestId}`, {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ shopId, reason: reason || "Cancelled from calendar" }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || `Cancel failed (${res.status})`);
  }
  return data;
}

/** TASK-537 — owner inbound pull from connected provider */
export function syncCalendar(shopId, body = {}) {
  return calendarFetch(`/sync/${shopId}`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

/** TASK-538 — owner health check + queue drain when healthy */
export function runCalendarMonitor(shopId) {
  return calendarFetch(`/monitor/${shopId}`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

/** TASK-522 — backfill Scheduled / In Progress / Completed onto calendar */
export function backfillServiceRequests(shopId, { dryRun = false } = {}) {
  const q = dryRun ? "?dry_run=1" : "";
  return calendarFetch(`/backfill-service-requests/${shopId}${q}`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}
